export default function Footer() {
  return (
    <footer className="main-footer">
      <strong>
        &copy; {new Date().getFullYear()}{' '}
        <span style={{ color: '#4e9af1', fontWeight: 600 }}>Permit Vault</span>
      </strong>
      &nbsp;&mdash;&nbsp;Multi-Agent Document Intelligence Platform
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.0.0 &nbsp;|&nbsp; Phase 1
      </div>
    </footer>
  );
}
